import styled from "styled-components";

export const HomeSectionStyled = styled.section`
  @media (max-width: 767px) {
    text-align: center;

    .home-container {
      h1 {
        font-size: 10px; /* Adjust the font size for mobile */
      }
      h2 {

        font-size: 5px;
        
      }
    }
  }
  color: #fff;
  position: relative;

  &::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    //background-color: rgba(0, 0, 0, 0.8);
    z-index: 2;
  }
  .home-container {
    z-index: 3;
    h1 {
      font-size: 40px;
      font-weight: 700;
      
    }
    h2 {
      color: #eee;
      font-family: "Raleway", sans-serif;
      font-size: 7px;
      margin-bottom: 30px;
    }
  }
`;
